import type { Router } from 'vue-router';

import { amplitudeEventsConfig } from '@/shared/config';

import type { WatchlistItem } from '../types';

/**
 * Opens SERP for a saved search, or SERP + offer details flow when the watchlist
 * row is tied to a specific offer hash (same as /search/:hashCode/deep_link/details/:offerHash).
 */
export function navigateFromWatchlistItem(router: Router, item: WatchlistItem) {
  if (item.hash) {
    router.push({
      name: 'OffersResults',
      params: {
        hashCode: item.search_query,
        source: amplitudeEventsConfig.SERP_OPEN_SOURCE.FAVORITES,
      },
      query: { offerHash: item.hash },
    });
    return;
  }

  router.push({
    name: 'OffersResults',
    params: {
      hashCode: item.search_query,
      source: amplitudeEventsConfig.SERP_OPEN_SOURCE.FAVORITES,
    },
  });
}
